<template>
  <AppLayout>
    <template #topbar>
      <GlobalTopbarSkeleton />
    </template>
    <template #sidebar>
      <NewGlobalSidebarSkeleton />
    </template>
    <template #main-content>
      <div class="loader-container">
        <FriedSpinner />
      </div>
    </template>
  </AppLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppLayout from './AppLayout.vue';
import GlobalTopbarSkeleton from './topbar/components/GlobalTopbarSkeleton.vue';
import NewGlobalSidebarSkeleton from './sidebar/components/NewGlobalSidebarSkeleton.vue';

export default defineComponent({
  components: {
    AppLayout,
    GlobalTopbarSkeleton,
    NewGlobalSidebarSkeleton,
  },
});
</script>

<style lang="scss">
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
